import { NgFor } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { OrderDetailService } from '@cutting/main/order/order-detail/order-detail.service';
import { SafeHtmlPipe } from '@cutting/main/shared/pipes/safe-html.pipe';

import { MapViewerDialogComponent } from './map-viewer-dialog/map-viewer-dialog.component';

@Component({
  selector: 'cutting-cutting-maps',
  templateUrl: './cutting-maps.component.html',
  styleUrls: ['./cutting-maps.component.scss'],
  standalone: true,
  imports: [NgFor, SafeHtmlPipe, MatCardModule],
  encapsulation: ViewEncapsulation.None,
})
export class CuttingMapsComponent {
  maps: string[] = [];
  selectedMaterialId = 0;

  mapViewerDialogRef: MatDialogRef<MapViewerDialogComponent>;

  @Input() set materialId(value: number) {
    this.selectedMaterialId = value;
    this.getMaps(value);
  }

  constructor(public dialog: MatDialog, private orderDetailService: OrderDetailService) {
    this.orderDetailService.onCuttingMapsChanged.subscribe((response: string[]) => {
      this.maps = response;
    });
  }

  getMaps(materialId: number): void {
    this.orderDetailService.getCuttingMaps(materialId);
  }

  openMapViewerDialog(mapSvg: string): void {
    this.mapViewerDialogRef = this.dialog.open(MapViewerDialogComponent, {
      disableClose: false,
      panelClass: 'map-viewer-dialog',
      width: '800px',
    });

    this.mapViewerDialogRef.componentInstance.mapSvg = mapSvg;

    this.mapViewerDialogRef.afterClosed().subscribe(() => {
      this.mapViewerDialogRef = null;
    });
  }
}
